import { TableCell, TableRow } from '@mui/material'
import { headColor } from '../../dashBoard/businessAnalysis'
export const RenderTableExcel = (props) => {
  const {  data, key1, key2, key3, showHeader = true, datacolStyle={} } = props
  let { header } = props
  header = header?.map((item) => {
    return {
      ...item,
      align: item.align ? item.align : item?.xlCol?.dataType === "quantity" ? 'right' : undefined,
    }
  })
  return (
    <>
      {showHeader ? <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
        {header.map((item, i) => (
          <TableCell
            className="ReportItemHead"
            key={key1 + i}
            style={{ textAlign: item.align, color: '#444444', fontSize: '20px', fontWeight: '600', backgroundColor: headColor.header, whiteSpace: 'nowrap' }}
          >
            {item.headerName}
          </TableCell>
        ))}
      </TableRow> : <></>}
      {data.length ? (
        <>
          {data.map((row, index) => (
            <TableRow className="receivedTr" key={key2 + index}>
              {(() => {
                let skip = 0

                return header.map((item, i, { length }) => {
                  const isLastIndex = i + 1 === length
                  if (skip > 0) {
                    skip--
                    return <></>
                  }
                  const colSpan = row.colSpan?.[item.field] || 1
                  skip = colSpan - 1

                  return (
                    <TableCell
                      className="reportTD"
                      key={key3 + i}
                      colSpan={colSpan}
                      style={{
                        fontSize: '20px', fontWeight: '600',
                        textAlign: colSpan > 1 ? 'left' : item.align,
                        color: isLastIndex && row.dataType !== 'subHeader' ? '#0086ff' : '#444444',
                        backgroundColor: headColor[row.dataType],
                        whiteSpace: 'nowrap',
                        ...datacolStyle
                      }}
                    >
                      {row[item.field]}
                    </TableCell>
                  )
                })
              })()}
            </TableRow>
          ))}
        </>
      ) : (
        <>
          <TableRow>
            <TableCell colSpan={header.length}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '20px',
                  marginBottom: '20px',
                  color: 'red',
                  fontSize: '14px',
                }}
              >
                <span>No results found. Please refine your search parameters and search again.</span>
              </div>
            </TableCell>
          </TableRow>
        </>
      )}
    </>
  )
}
